import React, { useEffect, useContext, useState } from 'react';
import { withRouter, useLocation, Redirect } from 'react-router-dom';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import styles from './Page.module.sass';
import Header from '../Header';
import Footer from '../Footer';
import Leftbar from '../Leftbar';
import Rightbar from '../Rightbar';
import MobileFooter from '../MobileFooter';
import Box from '@mui/material/Box';
import Preloader from '../Preloader';
import { ConquerContext } from '../../contexts/ConquerContext';
import { UserContext } from '../../contexts/UserContext';
import { ModalContext } from '../../contexts/Modal/ModalContext';
import EmailVerificationForm from '../AuthForms/EmailVerificationForm';
import cn from 'classnames';
import { useCallback } from 'react';

const Page = ({ noRightBar = true, noLeftBar = false, children}) => {

    const userContext = useContext( UserContext );
    const conquer = useContext( ConquerContext );
    const {show, hide} = useContext( ModalContext );

    useEffect(() => {
        window.scrollTo(0, 0);
        clearAllBodyScrollLocks();
    }, [location.pathname]);

    useEffect( () => {

        function doCheck(){

            if( !userContext.userData.isLogged ) return;
            if( userContext.userData.isVerified ) return hide();
            
            show( {content: <EmailVerificationForm email={userContext.userData.username}/>, title: 'Verify Email', closeButton: false, closeOutside: false,} );

        }
        doCheck();

    }, [userContext.userData]);

    return (
        <div className={cn(styles.page)}>
            <Preloader visibility={ !conquer }/>
            {
                conquer && (
                    <>
                        <Header />
                        <div className={cn(styles.inner, location.pathname.includes('chat') && styles.chat)}>
                            { !noLeftBar && <Leftbar className={cn(styles.column_left, !location.pathname.includes('chat') && styles.hide)}/> }
                            <div className={styles.column_center}>
                                {children}
                            </div>
                            {!noRightBar && (
                                <Box className={cn(styles.side_section, styles.column_right)}>
                                    <Rightbar />
                                </Box>
                            )}
                        </div>
                        <MobileFooter/>
                        {/* <Footer /> */}
                    </>
                )
            }      
        </div>
    );
};

export default withRouter(Page);
